import { FormEvent } from 'react'

export const formatOnlyNumberOnInput = (event: FormEvent) => {
  const element = event.target as HTMLInputElement

  if (!element) {
    return
  }

  element.value = element.value.replace(/[^0-9]/g, '')
}
